export default __webpack_public_path__ + "static/media/step1Character.a54b3f87.png";